<template>
	<transition name="error">
		<div class="exluded">
			<div class="delete_popup">
				<div class="delete_mes">
					<div>Вы точно хотите удалить пользователя "{{deletedUser.name}}"?</div>
					<div class="button">
						<button @click="deleteUser">Yes</button>
						<button @click="hiddenPopup">No</button>
					</div>
					<transition name="error">
						<div v-if="errorInDelete" class="error_in_delete">ошибка при удалении</div>
					</transition>
				</div>
			</div>
			<div class="button">
				<transition name="error" out-in>
					<button @click="createUser"
					        v-if="!newUser"
					        v-show="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'"
					>save new user
					</button>
					<button @click="exchangesUser"
					        v-show="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'"
					        v-if="newUser"
					>save user changes
					</button>
				</transition>
				<transition name="error">
					<button @click="newFieldsUser"
					        v-if="newUser"
					        v-show="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'"
					>create new user
					</button>
				</transition>
				<!--<button @click="clearFields">clear changes</button>-->
			</div>
			<transition name="error">
				<p class="exist"
				   :key="1"
				   v-if="existed">пользователь уже существует!</p>
				<p class="exist"
				   :key="2"
				   v-if="incorrect">не корректные данные!</p>
				<p class="exist"
				   :key="3"
				   v-if="access">нет доступа!</p>
				<p class="exist isOk"
				   :key="4"
				   v-if="savedSuccess">Успешно сохранено!</p>
				<p class="exist isOk"
				   :key="5"
				   v-if="deletedOldUser">Пользователь успешно удален!</p>
				<p v-if="macValid"
				   :key="6"
				   class="exist">невалидный MAC</p>
			</transition>
			<p class="exluded-text">Исключенные пользователи</p>
			<div class="user_header">
				<div class="cont-form">
					<div class="form">
						<label for="login">Логин</label>
						<input type="text"
						       id="login"
						       autocomplete="off"
						       @focus="blur"
						       :disabled="!(getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User')"
						       v-model="selectedUser.name">
					</div>
					<div class="form">
						<label for="region">Регион</label>
						<select id="region"
						        :disabled="!(getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User')"
						        v-model="selectedUser.region.name">
							<option v-for="item in regionList"
							        :value="item.name"
							        :key="item.name + '-' + item.operator"
							>{{item.display_name}} <span
								v-if="getReqUserRole === 'Администратор уровня Бог'">{{item.operator}}</span>
							</option>
						</select>
						<!--<input type="text"-->
						<!--id="region"-->
						<!--@focus="blur"-->
						<!--v-model="selectedUser.region.display_name">-->
					</div>
				</div>
				<div class="cont-form">
					<div class="form">
						<label for="pass">Пароль</label>
						<input type="text"
						       id="pass"
						       @focus="blur"
						       :disabled="!(getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User')"
						       v-model="selectedUser.password">
					</div>
					<div class="form">
						<label for="comment">Комментарий</label>
						<input type="text"
						       id="comment"
						       :disabled="!(getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User')"
						       @focus="blur"
						       v-model="selectedUser.comment">
					</div>
				</div>
				<div class="cont-form"
				     v-if="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'">
					<div class="form"
					     v-if="getReqUserRole === 'Администратор уровня Бог'">
						<label for="operator">Оператор</label>
						<select id="operator"
						        v-model="selectedUser.operator.name">
							<option v-for="item in operatorList"
							        :value="item.name"
							        :key="item.name"
							>{{item.display_name }}
							</option>
						</select>
					</div>
					<div class="form"
					     v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">
						<label for="mac">MAC-адрес</label>
						<input type="text"
						       id="mac"
						       @focus="blur"
						       autocomplete="off"
						       v-model="selectedUser.mac">
					</div>
				</div>
			</div>
			<div class="fixed">
				<div class="user">
					<p>Имя пользователя</p>
					<p>MAC-адресс</p>
					<p v-if="getCurrentOperator === 'kvant-telecom' || getReqUserRole === 'Администратор уровня Бог'">Оператор</p>
					<p>Регион</p>
					<p>Дата добавления</p>
					<p>Комментарий</p>
					<p class="on_off" v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">
						вкл/выкл</p>
				</div>
			</div>
			<!--<div class="container">-->
			<vue-scroll class="container" :ops="ops">
				<div class="user check"
				     :class="user.enabled ? null : 'disabled'"
				     v-for="(user, i) in arr"
				     @click="editUser(i, $event)"
				     :key="i">
					<p class="selected"></p>
					<p>{{ user.name }}</p>
					<p>{{ user.mac }}</p>
					<p v-if="getCurrentOperator === 'kvant-telecom' || getReqUserRole === 'Администратор уровня Бог'"
					>{{ user.operator.display_name }}</p>
					<p>{{ user.region.display_name }}</p>
					<p>{{ addedUser(user) }}</p>
					<p>{{ user.comment }}</p>
					<p class="checkbox"
					   v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">
						<input type="checkbox"
						       :id="'activ' + i"
						       name="feature"
						       value="activ"
						       :checked="user.enabled"
						       @click.stop
						       title=""
						/>
						<label :for="'activ' + i"
						       @click="thisEnabled(i)"
						>{{ user.enabled ? "включен" : "выключен" }}</label>
						<button class="delete"
						        @click.stop="showPopup(user.name, user.uid, user.operator.name)"
						>delete
						</button>
					</p>
				</div>
			</vue-scroll>
			<!--</div>-->
		</div>
	</transition>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapGetters }     from "vuex";
	import isMACAddress       from "validator/lib/isMACAddress";

	export default {
		name:     "excluded",
		data() {
			return {
				arr:            [],
				selectedUser:   {
					name:     "",
					mac:      "",
					password: "",
					comment:  "",
					operator: {
						name:         "kvant-telecom",
						display_name: "Квант-телеком"
					},
					region:   {
						name:         "",
						display_name: ""
					}
				},
				existed:        false,
				incorrect:      false,
				access:         false,
				savedSuccess:   false,
				newUser:        false,
				deletedOldUser: false,
				errorInDelete:  false,
				old_uid:        "",
				operatorList:   [],
				regionList:     [],
				selectOperator: "",
				macValid:       false,
				deletedUser:    {
					name: "",
					uid:  ""
				},
				ops:            {
					rail:     {
						opacity:             0,
						size:                "6px",
						specifyBorderRadius: false,
						gutterOfEnds:        "4px",
						gutterOfSide:        "4px",
						keepShow:            false
					},
					bar:      {
						showDelay:           500,
						onlyShowBarOnScroll: false,
						keepShow:            true,
						background:          "#c1c1c1",
						opacity:             1,
						hoverStyle:          false
					}
				}
			};
		},
		beforeMount() {
			this.getExUsers();
			this.getOperators();
			this.getRegions();
			console.log(this.getViewUser);
		},
		computed: {
			...mapGetters([
				"getUserRights",
				"getReqUserRole",
				"getCurrentOperator",
				"getViewUser"
			]),
		},
		methods:  {
			thisEnabled(i) {
				this.arr[i].enabled = !this.arr[i].enabled;
				let enabled         = this.arr[i].enabled === true ? 1 : 0;
				setTimeout(() => {
					this.addUser("updateExUser", enabled, false);
				}, 0);

			},
			test() {
				console.log(this.selectOperator);
			},
			showPopup(name, uid, operator) {
				this.deletedUser.name     = name;
				this.deletedUser.uid      = uid;
				this.deletedUser.operator = operator;
				document.querySelector(".delete_popup").classList.add("show");
				this.blur();
			},
			hiddenPopup() {
				document.querySelector(".delete_popup").classList.remove("show");
				this.errorInDelete = false;
			},
			deleteUser() {
				console.log(this.deletedUser);
				performRequest(
					{
						section: "user.exuser",
						name:    "deleteExUser",
					},
					{
						uid:      this.deletedUser.uid,
						operator: this.deletedUser.operator
					}
					,
					a => {
						if (a.code === 200) {

							this.hiddenPopup();
							this.newFieldsUser();
							this.deletedOldUser = true;
							setTimeout(() => {
								if (this.deletedOldUser === true) {
									this.deletedOldUser = false;
								}
							}, 2000);
						} else {
							this.errorInDelete = true;
							setTimeout(() => {
								if (this.errorInDelete === true) {
									this.errorInDelete = false;
								}
							}, 2000);
							console.log(
								"ошибка при удалении"
							);
						}
					}
				);
			},
			addedUser(user) {
				return (
					`${user.added.split("T")[0]} ${user.added.split("T")[1].split(".")[0]}`
				);
			},
			editUser(i, $event) {
				[].forEach.call($event.currentTarget.parentNode.children, elem => {
					if (elem.firstChild.classList.contains("show")) {
						elem.firstChild.classList.remove("show");
					}
				});
				$event.currentTarget.firstChild.classList.add("show");
				for (let sliceElementKey in this.arr.slice(i, i + 1)[0]) {
					if (this.arr.slice(i, i + 1)[0].hasOwnProperty(sliceElementKey)) {
						this.selectedUser[sliceElementKey] = this.arr.slice(i, i + 1)[0][sliceElementKey];
					}
				}
				this.old_uid = this.arr[i].uid;
				this.newUser = true;
				this.blur();
			},
			clearFields() {
				this.selectedUser = {
					name:     "",
					mac:      "",
					password: "",
					comment:  "",
					operator: {
						name:         "kvant-telecom",
						display_name: "Квант-телеком"
					},
					region:   {
						name:         this.regionList[0].name,
						display_name: this.regionList[0].display_name
					}
				};
			},
			newFieldsUser() {
				this.clearFields();
				this.getExUsers();
				this.clearSelect();
				this.old_uid = "";
				this.newUser = false;
				this.blur();
				document.querySelector("#login").focus();
			},
			getOperators() {
				if (this.getReqUserRole === "Администратор уровня Бог") {
					performRequest(
						{
							section: "tvcontent.operator",
							name:    "getOperatorList"
						},
						{
							operator: this.getViewUser
						},
						a => {
							if (a.code === 200) {
								this.operatorList = a.data;
								console.log(a);
							} else {
								console.log("ошибка загрузки списка операторов");
							}
						});
				}

			},
			getRegions() {
				performRequest(
					{
						section: "tvcontent.region",
						name:    "getRegionList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.regionList                       = a.data;
							this.selectedUser.region.display_name = this.regionList[0].display_name;
							this.selectedUser.region.name         = this.regionList[0].name;
						} else {
							console.log("ошибка загрузки списка операторов");
						}

					});
			},
			getExUsers() {
				performRequest(
					{
						section: "user.exuser",
						name:    "getExUserList",
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.arr = a.data.reverse();
						} else {
							console.log(
								"ошибка при получении доступных каналов"
							);
						}
					}
				);
			},
			exchangesUser() {
				this.addUser("updateExUser", 1);
			},
			createUser() {
				this.addUser("createExUser", 1);
			},
			clearSelect() {
				[].forEach.call(document.querySelectorAll(".user.check"), elem => {
					if (elem.firstChild.classList.contains("show")) {
						elem.firstChild.classList.remove("show");
					}
				});
			},
			addUser(command, enabled = 1, val = true) {
				let root = true;

				let data = {
					login:    this.selectedUser.name,
					password: this.selectedUser.password,
					region:   this.selectedUser.region.name,
					comment:  this.selectedUser.comment,
					enabled:  enabled,
					mac:      ""
				};

				if (command === "updateExUser") {
					data.old_uid = this.old_uid;
				}

				if (this.getReqUserRole === "Администратор уровня Бог" || this.getReqUserRole === "Power User") {
					data.operator = this.selectedUser.operator.name;
					data.mac      = this.selectedUser.mac;
				}

				if (this.getReqUserRole === "Администратор уровня Бог" || this.getReqUserRole === "Power User") {
					if (this.selectedUser.mac !== "") {
						isMACAddress(data.mac) ? root = true : root = false;
					}
				}
				data.operator = this.getViewUser;
				if (root) {
					performRequest(
						{
							section: "user.exuser",
							name:    command,
						},
						data
						,
						a => {
							if (a.code === 400) {
								this.incorrect = true;
								setTimeout(() => {
									if (this.incorrect === true) {
										this.incorrect = false;
									}
								}, 2000);
							} else if (a.code === 200) {
								this.savedSuccess = true;
								setTimeout(() => {
									if (this.savedSuccess === true) {
										this.savedSuccess = false;
									}
								}, 2000);
								this.getExUsers();
								this.old_uid = "";
								if (val) {
									this.clearSelect();
									this.selectedUser = {
										name:     "",
										mac:      "",
										password: "",
										comment:  "",
										operator: {
											name:         "kvant-telecom",
											display_name: "Квант-телеком"
										},
										region:   {
											name:         this.regionList[0].name,
											display_name: this.regionList[0].display_name
										}
									};
								}

							} else if (a.code === 403) {
								this.access = true;
								setTimeout(() => {
									if (this.access === true) {
										this.access = false;
									}
								}, 2000);
							} else if (a.code === 409) {
								this.existed = true;
								setTimeout(() => {
									if (this.existed === true) {
										this.existed = false;
									}
								}, 2000);
							}
						}
					);
				} else {
					this.macValid = true;
					setTimeout(() => {
						if (this.macValid === true) {
							this.macValid = false;
						}
					}, 2000);
				}

			},
			blur() {
				this.existed        = false;
				this.incorrect      = false;
				this.access         = false;
				this.savedSuccess   = false;
				this.deletedOldUser = false;
			},
			back(e) {
				console.log(e);
			},
		},
	};
</script>
<style scoped lang="scss">
	$width_container_button: 24px;
	$width_button_item: $width_container_button - 8;
	$height_button: 2px;
	$height_add: 208px;
	$width_add: $height_add / 4;
	$bd_button: 8px;
	.exluded {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		padding: 0.5rem 0.5rem 1rem 0.5rem;
		height: calc(100vh - 5rem);
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		transform: translateX(50%);
		min-width: 1020px;
		.delete_popup {
			position: absolute;
			display: none;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1000;
			background-color: rgba(255, 255, 255, 0.31);
			.error_in_delete {
				position: absolute;
				color: red;
				left: 50%;
				bottom: 5px;
				transform: translateX(-50%);
			}
			.delete_mes {
				width: 400px;
				height: 120px;
				background-color: #fff;
				box-shadow: inset 0 0 10px #9d9d9d;
				border-radius: 5px;
				margin-left: 50%;
				margin-top: 30%;
				transform: translateX(-50%);
				position: relative;
				padding: 20px;
				text-align: center;
				.button {
					position: absolute;
					bottom: 30px;
					left: 50%;
					transform: translateX(-50%);
				}
			}
			&.show {
				display: block;
			}
		}
		.exluded-text {
			position: absolute;
			top: 7px;
			right: 20px;
		}
		.button {
			position: absolute;
			left: 2.6rem;
			display: flex;
			flex-direction: row;
			button {
				margin-right: 0.5rem;
				line-height: 0;
			}
			
		}
		.exist {
			background-color: rgba(238, 160, 154, 0.6);
			border-radius: 5px;
			padding: 4px 10px 5px 10px;
			top: 6px;
			font-weight: bold;
			position: absolute;
			margin-left: 350px;
			color: #940000;
			font-size: 1.1rem;
			z-index: 1000;
		}
		.isOk {
			background-color: rgba(137, 238, 154, 0.6);
			color: #008d94;
		}
		.fixed {
			position: absolute;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			width: calc(100% - 1rem);
			top: 11.5rem;
			margin: auto;
			padding-right: 1rem;
			font-size: 16px;
			border: 1px solid #ccc;
			border-radius: 0;
			.user {
				margin: 5px 0;
				p {
					padding-left: 1rem;
					font-size: 1rem;
				}
			}
		}
		.container {
			background-color: #3b3463;
			border-radius: 5px;
			/*!*overflow-y: scroll;*!*/
			margin-top: 15rem;
			max-height: calc(100vh - 21rem);
			padding-bottom: 1rem;
			color: #fff;
			p.checkbox {
				min-width: 200px;
				input {
					display: none;
				}
				label, .delete {
					cursor: pointer;
					padding: 1px 5px 3px 5px;
					width: 80px;
					text-align: center;
					margin: 2px 5px;
					border-radius: 5px;
					background-color: rgba(0, 222, 0, 0.27);
					box-shadow: 0 0 5px #000;
					transition: background-color 0.2s;
					
				}
				.delete {
					background-color: #fcccb2;
					&:hover {
						color: #fff;
						background-color: #c38c88;
						&:active {
							box-shadow: 0 0 1rem #967068;
						}
					}
				}
			}
			
			.user.check {
				position: relative;
				border-bottom: 2px solid #6c757d;
				height: 3rem;
				transition: background-color 0.3s;
				p {
					font-size: .85rem;
					display: flex;
					align-items: center;
					padding-left: 1rem;
					cursor: default;
				}
				.selected {
					display: none;
					position: absolute;
					top: 0;
					left: -20px;
					border-left: 20px solid rgba(255, 255, 255, 0.58);
					border-bottom: 20px solid transparent;
					border-top: 20px solid transparent;
					height: 20px;
					&.show {
						display: block;
					}
				}
				&:first-child {
					margin-top: 1rem;
				}
				&:hover {
					background-color: rgba(194, 213, 255, 0.34);
					/*color: #000;*/
					label {
						color: #fff;
					}
					
				}
			}
			.disabled {
				background-color: rgba(122, 87, 133, 0.76);
			}
			.disabled {
				p.checkbox {
					label {
						background-color: rgba(221, 0, 34, 0.31);
					}
				}
			}
		}
		.user,
		.user_header {
			clear: both;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			width: 90%;
			margin: auto;
			.on_off {
				min-width: 200px;
			}
			p {
				width: calc(100% / 5);
				text-align: left;
				padding: 0;
				margin: 0;
				label,
				button {
					font-size: .9rem;
					height: 25px;
					line-height: 1.5rem;
				}
				
			}
		}
		
		.user_header {
			position: fixed;
			width: 98%;
			top: 3rem;
			display: flex;
			.cont-form {
				width: 46%;
				justify-content: space-around;
				.form {
					flex-grow: 1;
					padding-left: 10px;
					display: flex;
					flex-direction: column;
					input, select {
						border-radius: 3px;
						height: 25px;
						outline: none;
						border: 1px solid #c9c9c9;
						padding-left: 5px;
						flex-grow: 1;
						margin-bottom: 5px;
						max-height: 2rem;
						&:focus {
							box-shadow: 0 0 5px #69bf8f;
						}
					}
				}
				p {
					text-align: center;
					text-transform: uppercase;
					font-weight: bold;
				}
			}
		}
		button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			max-height: 2rem;
			&:hover {
				background: #78956b;
				color: white;
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
	}
	@media (max-width: 620px) {
		/*.exluded {*/
		/*height: calc(100vh - 9rem);*/
		/*min-width: 570px;*/
		/*margin-top: 8rem;*/
		/*overflow: auto;*/
		/*.container {*/
		/*overflow: auto;*/
		/*height: calc(100vh - 24.5rem);*/
		/*}*/
		/*}*/
	}
	.exluded-enter-active {
		transition: all 0.5s ease;
	}
	.exluded-leave-active {
		transition: all 0.5s ease;
	}
	.exluded-enter,
	.exluded-leave-to {
		opacity: 0;
	}
	.error-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter,
	.error-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/ExcludedIPTVUsers.vue